import React from 'react';
import { useTranslate } from 'ra-core';
export const DocumentTitle = () => {
    const translate = useTranslate();
    return (React.createElement("span", null, translate(`resources.documents.name`, {
        smart_count: 2,
    })));
};
//# sourceMappingURL=DocumentTitle.js.map